export default "__VITE_ASSET__CATTiuGW__"